import { Capacitor } from "@capacitor/core"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { FormDomainOutlet } from "~/routes/share-form"
import { BreakpointIndicator } from "~/components/BreakpointIndicator"
import { LinkContextMenuProvider } from "~/components/Link"
import { UpdateGate } from "~/components/native/UpdateGate"
import { DiscordActivityProvider } from "~/components/providers/DiscordActivity"
import { NativeAppCapabilities } from "~/components/providers/NativeAppCapabilities"
import { NativeNotifications } from "~/components/providers/NativeNotifications"
import { PostHogProvider } from "~/components/providers/Posthog"
import { ThemeProvider } from "~/components/providers/Theme"
import { Toaster } from "~/components/ui/sonner"
import { cn } from "~/lib/utils"
import { TRPCReactProvider } from "~/trpc/react"

export function RootLayout() {
	const nativeApp = Capacitor.isNativePlatform()

	const app = (
		<TRPCReactProvider>
			<ThemeProvider>
				<DiscordActivityProvider>
					<PostHogProvider>
						{nativeApp && <NativeAppCapabilities />}
						{nativeApp && <NativeNotifications />}
						<LinkContextMenuProvider>
							<div className={cn(nativeApp && "orbit-native-shell")}>
								<FormDomainOutlet />
							</div>
						</LinkContextMenuProvider>
						{import.meta.env.DEV && (
							<ReactQueryDevtools initialIsOpen={false} />
						)}
						<Toaster />
					</PostHogProvider>
					<BreakpointIndicator />
				</DiscordActivityProvider>
			</ThemeProvider>
		</TRPCReactProvider>
	)

	if (nativeApp) return <UpdateGate>{app}</UpdateGate>

	return app
}
